import { Box, TableBody, TableCell, TableHead, TableRow, Table, Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ApiImportExportAllocationPoints } from '../../../apiService/Core/Apicall.tsx';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';

const AdminDashboard: React.FC = () => {
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const [allocationPoints, setallocationPoints] = useState<any>([]);
  const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
  const navigate = useNavigate()


  const ponitsdata = async () => {
    try {
      const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
      const res = await ApiImportExportAllocationPoints(data)
      setallocationPoints(res.data)

    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {
    ponitsdata()
  }, [])

  useEffect(() => {
    if (selectedDateRedux) {
      setCurrentDate(new Date(selectedDateRedux))
    }
  }, [selectedDateRedux])

  return (

    <Box className='d-flex flex-column align-items-center px-3' height='fit-content' pt='20px'>
      <Box width={{xs:'100%',md:"75vw"}} bgcolor='white' className='text-center mb-3' borderRadius='10px' boxShadow='0px 0px 10px black' padding='40px 20px'>
        <h3> Quick Links</h3>
        <hr />
        {/* <Box className='d-flex justify-content-center'  gap={3}>
          <Button
            sx={{ color: 'white', textTransform: 'none', }}
            onClick={() => { navigate('/admin/manage-reports') }}
            className="action-button  action-button--approve table-row-background">
            Manage Report
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/venue-managers') }}
            className="action-button  action-button--approve table-row-background">
            Manage Venues
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { navigate('/admin/shoppers/shoppers-list') }}
            className="action-button  action-button--approve table-row-background">
            Active Shoppers
          </Button>
          <Button
            sx={{ color: 'white', textTransform: 'none' }}
            onClick={() => { window.open('/admin/allocations/monthly-calendar', '_blank'); }}
            className="action-button  action-button--approve table-row-background">
            Monthly Calendar
          </Button>
        </Box> */}
        <Grid container spacing={2} alignItems={'center'} justifyContent="center">
          <Grid size={{xs:6, md:'auto'}}>
            <Link
              style={{ color: 'white', borderRadius:'4px', textTransform: 'none' }}
              // component={Link}
              to={'/admin/manage-reports'}
              // onClick={() => navigate('/admin/manage-reports')}
              className="action-button p-2  fs-14  action-button--approve table-row-background"
              // fullWidth
            >
              Manage Report
            </Link>
          </Grid>

          <Grid size={{xs:6, md:'auto'}}>
            <Link
              style={{ color: 'white', borderRadius:'4px', textTransform: 'none' }}
              to={'/admin/venue-managers'}
              // onClick={() => navigate('/admin/venue-managers')}
              className="action-button p-2  fs-14  action-button--approve table-row-background"
            >
              Manage Sites
            </Link>
          </Grid>

          <Grid size={{xs:6, md:'auto'}}>
            <Link
              style={{ color: 'white',borderRadius:'4px', textTransform: 'none' }}
              to={'/admin/shoppers/shoppers-list'}
              // onClick={() => navigate('/admin/shoppers/shoppers-list')}
              className="action-button p-2 fs-14 action-button--approve table-row-background"
            >
              Active Shoppers
            </Link>
          </Grid>

          <Grid size={{xs:6, md:'auto'}}>
            <Link
              style={{ color: 'white',borderRadius:'4px', textTransform: 'none' }}
              to={'/admin/allocations/monthly-calendar'}
              // onClick={() => window.open('/admin/allocations/monthly-calendar', '_blank')}
              className="action-button p-2 fs-14 action-button--approve table-row-background"
              // fullWidth
            >
              Monthly Calendar
            </Link>
          </Grid>
        </Grid>
      </Box>
      <Box bgcolor='white' className='text-center w-100' borderRadius='10px' boxShadow='0px 0px 10px black' padding='40px 20px'>
        <Typography fontSize={{xs:"24px", md:"32px"}} className='mb-2 mb-md-5 mx-auto' style={{ width: 'fit-content'}}>Welcome <strong className='text-light px-3 px-md-4 py-1' style={{ borderRadius: '10px', backgroundColor: '#7a7d52'}}>{localStorage.getItem('userName')}</strong></Typography>
          <Typography fontSize={{xs:"24px", md:"32px"}} className='mb-2'>Current Month Summary</Typography>
        <Box className='mx-0 d-flex flex-column' sx={{width:"100% !important", overflow:'auto'}}>
          <Table>
            <TableHead sx={{ bgcolor: "#7a7d52" }}>
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Site name</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Total Jobs</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Allocated</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Pending Approval</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Orphan</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Completed</TableCell>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder' }}>Pending</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allocationPoints?.ALDI && allocationPoints?.ALDI?.map((item) => (
                <TableRow>
                  <TableCell className='text-light text-center py-4 fs-18' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>{item?.entityName}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.totalJobs}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.allocated}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.pendingApproval}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.orphan}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.completed}</TableCell>
                  <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{item?.pending}</TableCell>
                </TableRow>

              ))}
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{fontWeight: 'bolder', bgcolor: "#7a7d52" }}>BLOOMS</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.totalJobs}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.allocated}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pendingApproval}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.orphan}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.completed}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>MM</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.totalJobs}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.allocated}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.pendingApproval}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.orphan}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.completed}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.MM?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Transport</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.totalJobs}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.allocated}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pendingApproval}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.orphan}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.completed}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Extended</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.totalJobs}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.allocated}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.pendingApproval}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.orphan}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.completed}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.pending}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-light text-center py-4 fs-18' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>JBHIFI</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.totalJobs}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.allocated}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.pendingApproval}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.orphan}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.completed}</TableCell>
                <TableCell className='text-center fs-18' sx={{fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.pending}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>

    </Box>
  );
};

export default AdminDashboard;
